/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useEffect} from "react";
import { $} from "../../../../../vendor";
import AbonnementsItem from "./AbonnementsItem";
 const AbonnementsList = (props: any) => {
     const {abonnements, dispatch, getList, deleteAbonnement, filter, setFilter, sort, setSort, _key, setKey} = props;


    useEffect(() =>{
        if(props?._key !== null){
            let selector: string = '[key='+props._key+']';
            if ($(selector)?.length >= 1) {
                // @ts-ignore
                $('html,body')?.scrollTop($(selector)?.offset()?.top - 10)
            }
        }
    },[]) ;




     return (
         <>
             <div className='inb-c-listing off-canvas-content' id="inb-c-main-orders" style={{ minHeight: "1150px",paddingTop:"10px"}}>

                 { typeof abonnements !== 'undefined' && abonnements.length > 0 && abonnements.map((abonnement:any, index:number) => {
                     return(
                             <AbonnementsItem
                                 abonnement={abonnement}
                                 dispatch={dispatch}
                                 getList={getList}
                                 deleteAbonnement={deleteAbonnement}
                                 filter={filter}
                                 setFilter={setFilter}
                                 sort={sort}
                                 setSort={setSort}
                                 _key={_key}
                                 setKey={setKey}
                                 />)})}
                     </div>
                     </>);



 };
 export default AbonnementsList;